// Centralized UI feature flags (safe to toggle without removing features)
export const SHOW_USDT_WITHDRAW_MENU = true;

